import Thumbnail from "./Thumbnail";

export { Thumbnail as default };
